export const FORCED_PASSWORD_CHANGE_URL = '/account.html#change-password';

export function isAccountRoute(activeRoute: string): boolean {
  return activeRoute === 'account.html';
}
